export enum CollabSuggestionStatusEnum {
  pending = "pending",
  accepted = "accepted",
  rejected = "rejected",
}

export interface CollabSuggestionPost {
  title: string
  canonical_url: string | null
  thumbnail_url: string | null
  creator: string | null
  source: string | null
}

export interface CollabSuggestion {
  id: number
  status: CollabSuggestionStatusEnum
  notes: string | null
  url: string | null
  created_at: string
  contributor_name: string
  contributor_avatar_url: string | null
  post: CollabSuggestionPost
}
